import { Chip, Link, Stack, Typography } from "@mui/material";

import LabelAndDisplay from "../../components/LabelAndDisplay";
import RevisionDeviationDetails from "./RevisionDeviationDetails";

function PriceHistoryRecordView({ item }) {
  if (!item) {
    return (
      <Typography variant="body2" color="text.secondary">
        No record selected.
      </Typography>
    );
  }

  return (
    <Stack spacing={2}>
      <LabelAndDisplay label="Record ID" value={item.id || "—"} />
      <LabelAndDisplay label="Date" value={item.recordAt} />
      <LabelAndDisplay label="Product" value={item.product} />
      <LabelAndDisplay label="Retailer">
        <Typography variant="body1" component="div">
          {item.retailer}
          {" — "}
          {item.googleMapsUrl ? (
            <Link
              href={item.googleMapsUrl}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
            >
              {item.gpsCoordinatesLabel}
            </Link>
          ) : (
            <Typography component="span" color="text.secondary">
              No GPS
            </Typography>
          )}
        </Typography>
      </LabelAndDisplay>
      <LabelAndDisplay label="Province" value={item.province} />
      <LabelAndDisplay label="Unit price" value={item.unitPrice} />
      <LabelAndDisplay label="Price" value={item.price} />
      <LabelAndDisplay label="Weight" value={item.weight} />
      <LabelAndDisplay label="Human verified">
        {item.verified ? (
          <Chip size="small" color="success" label="Verified" />
        ) : (
          <Chip size="small" variant="outlined" label="Not verified" />
        )}
      </LabelAndDisplay>

      <RevisionDeviationDetails
        revisionStatus={item.revisionStatus}
        revisionMetadata={item.revisionMetadata}
        unitPriceValue={item.unitPriceValue}
      />
    </Stack>
  );
}

export default PriceHistoryRecordView;
